type PlaceholderPageProps = {
  title: string;
  description: string;
};

/** Temporary full-viewport placeholder until content slices land. */
export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <section className="mx-auto flex w-full max-w-7xl flex-col justify-center px-4 py-20 sm:px-6 lg:min-h-[60vh] lg:px-8">
      <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
        NextOnVera
      </p>
      <h1 className="font-display text-foreground max-w-3xl text-3xl font-semibold tracking-tight sm:text-4xl md:text-5xl">
        {title}
      </h1>
      <p className="text-muted-foreground mt-4 max-w-2xl text-base leading-relaxed sm:text-lg">
        {description}
      </p>
    </section>
  );
}
